import { render, staticRenderFns } from "./ArtigosFruchterman.vue?vue&type=template&id=046c9a4f&scoped=true&"
import script from "./ArtigosFruchterman.vue?vue&type=script&lang=js&"
export * from "./ArtigosFruchterman.vue?vue&type=script&lang=js&"
import style0 from "./ArtigosFruchterman.vue?vue&type=style&index=0&id=046c9a4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046c9a4f",
  null
  
)

export default component.exports